<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div class="modal-container">

          <div class="modal-body">
            <slot></slot>
          </div>

          <div class="modal-footer">
            <button class="modal-close-button" @click="$emit('close')">閉じる</button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "Modal"
  }
</script>

<style scoped>

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 560px;
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-body {
    height: 315px;
  }

  .modal-footer {
    padding: 8px 0;
    text-align: center;
    color: #FFFFFF;
  }

  .modal-close-button {
    width: 100%;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  @media screen and (max-width: 600px) {

    .modal-container {
      width: 263px;
    }

    .modal-body {
      height: 148px;
    }

  }

</style>